import { TRootState } from '../reducers';
import { IFieldState } from '../reducers/types';

export const selectFieldState = (state: TRootState): IFieldState => state.field;

export const selectFieldNodeId = (state: TRootState): string | undefined => {
  return state.field.nodeId;
};

export const selectIsChange = (state: TRootState): boolean | undefined => {
  return state.field.change;
};

export const selectHasLimitError = (state: TRootState): boolean | undefined => {
  const { maxLength, value } = state.field;
  return maxLength > 0 && maxLength - value.length < 0;
};
